import { mapGuestsToSubmissionData, type GuestInfo } from '@entities/leadCollector';

const emptyMainGuest: GuestInfo = {
  FIO: [],
  additionalFields: [],
};

export const buildSecondarySubmissionInfo = (adultGuests: GuestInfo[], childrenGuests: GuestInfo[]): string => {
  const data = mapGuestsToSubmissionData({
    mainGuest: emptyMainGuest,
    adultGuest: adultGuests,
    childrenGuest: childrenGuests,
  });
  return JSON.stringify({
    adultGuests: data.adultGuests,
    childrenGuests: data.childrenGuests,
  });
};
